import { render, staticRenderFns } from "./MaterialLabelPrintList.vue?vue&type=template&id=7620c1fa&scoped=true&"
import script from "./MaterialLabelPrintList.vue?vue&type=script&lang=js&"
export * from "./MaterialLabelPrintList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7620c1fa",
  null
  
)

export default component.exports